import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { ContainerBase } from '../../../core/base/container-base';
import * as fromOrderHistory from '../../reducers';
import * as fromAuth from '../../../auth/reducers';
import * as orderhistory from '../../actions/order-history.actions';
var OrderhistoryPageContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(OrderhistoryPageContainerComponent, _super);
    function OrderhistoryPageContainerComponent(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        // Observables
        _this.orderHistory$ = store.pipe(select(fromOrderHistory.getOrderHistory), takeUntil(_this.destroyed$));
        _this.loading$ = store.pipe(select(fromOrderHistory.getOrderHistoryLoading), takeUntil(_this.destroyed$));
        _this.expanding$ = store.pipe(select(fromOrderHistory.getOrderHistoryExpanding), takeUntil(_this.destroyed$));
        _this.currency$ = store.pipe(select(fromAuth.getCurrency), takeUntil(_this.destroyed$));
        return _this;
    }
    OrderhistoryPageContainerComponent.prototype.ngOnInit = function () {
        this.store.dispatch(new orderhistory.LoadOrderHistory());
    };
    OrderhistoryPageContainerComponent.prototype.expand = function () {
        this.store.dispatch(new orderhistory.LoadOrderHistoryExpand());
    };
    return OrderhistoryPageContainerComponent;
}(ContainerBase));
export { OrderhistoryPageContainerComponent };
